const MANAGE_USER_GROUP_SLUGS = new Set([ 'admin', 'developer' ]);


export const canManageUserGroups = (me) => {

    const roleSlug = typeof me?.role?.slug === 'string' ? me.role.slug.trim().toLowerCase() : '';

    return MANAGE_USER_GROUP_SLUGS.has(roleSlug);
};

